
import { useNavigate as useRouterNavigate } from "react-router-dom";

export const useNavigation = () => {
  const navigate = useRouterNavigate();

  const navigateAndScroll = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return navigateAndScroll;
};
